<div
  class="guide-overlay"
  [attr.data-arrow]="arrowSide"
  role="dialog"
  aria-live="polite"
  aria-labelledby="guide-overlay-title"
>
  <div class="guide-overlay__card">
    <span class="guide-overlay__arrow" aria-hidden="true"></span>
    <div class="guide-overlay__accent" aria-hidden="true"></div>
    <div class="guide-overlay__body">
      <p class="guide-overlay__eyebrow">Tutorial</p>
      <h4 class="guide-overlay__title" id="guide-overlay-title">{{ step.title }}</h4>
      <p class="guide-overlay__text" [innerHTML]="step.text"></p>
      <div class="guide-overlay__actions">
        <button type="button" class="guide-overlay__action guide-overlay__action--ghost" (click)="onSkip()">
          Pular
        </button>
        <div class="guide-overlay__actions-main">
          <button type="button" class="guide-overlay__action guide-overlay__action--secondary" (click)="onPrevious()">
            Voltar
          </button>
          <button type="button" class="guide-overlay__action guide-overlay__action--primary" (click)="onNext()">
            Avançar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
